import AllergenDto from "./AllergenDto";
import FoodTypeDto from "./FoodTypeDto";
import ItemExtraDto from "./ItemExtraDto";
import ItemOptionGroupDto from "./ItemOptionGroupDto";
import ItemLanguageDto from "./language/item/ItemLanguageDto";

export default class ItemDto {
    id: number;
    price: number;
    allergens: AllergenDto[];
    foodTypes: FoodTypeDto[];
    imageUrl: string;
    symbolicImage: boolean;
    disabled: boolean;
    itemType: 'FOOD' | 'DRINK';
    itemExtras: ItemExtraDto[];
    itemOptionGroups: ItemOptionGroupDto[];
    value: ItemLanguageDto;
    constructor(id: number, price: number, allergens: AllergenDto[], foodTypes: FoodTypeDto[], imageUrl: string, symbolicImage: boolean, disabled: boolean, itemType: 'FOOD' | 'DRINK', itemExtras: ItemExtraDto[], itemOptionGroups: ItemOptionGroupDto[], value: ItemLanguageDto) {
        this.id = id;
        this.price = price;
        this.allergens = allergens;
        this.foodTypes = foodTypes;
        this.imageUrl = imageUrl;
        this.symbolicImage = symbolicImage;
        this.disabled = disabled;
        this.itemType = itemType;
        this.itemOptionGroups = itemOptionGroups;
        this.itemExtras = itemExtras;
        this.value = value;
    }
}